import React, { useEffect, useState } from "react";
import { Alert, Card, Table, Tooltip } from "antd";
import { getNotesApprenants } from "../../../../api/geoprod";
import { useLoader } from "../../../../context/LoaderContext";
import { useLocation } from "react-router-dom";

const ListeNotesApprenants = () => {
  const {isLoading , setIsLoading } = useLoader();
  const [apprenants, setApprenants] = useState([]);
  const [columns, setColumns] = useState([]);
  const params = useLocation();
  const id_affaire  = params?.state?.id_affaire
  useEffect(() => {
    // setLoading(true);
    getNotesApprenants(id_affaire)
      .then(({ list: rawData }) => {
        const apprenantMap = new Map();
        const periodeModules = {};

        // 1) Extraire apprenants et modules par période et par type (examen/rattrapage)
        Object.entries(rawData).forEach(([periode, types]) => {
          periodeModules[periode] = {};

          Object.entries(types).forEach(([typeExamen, notes]) => {
            notes.forEach((note) => {
              if (!apprenantMap.has(note.id_apprenant)) {
                apprenantMap.set(note.id_apprenant, {
                  id: note.id_apprenant,
                  nom: note.surname,
                  prenom: note.name,
                  mail: note.adresse_mail,
                  cin: note.cin,
                });
              }

              if (!periodeModules[periode][note.key_module]) {
                periodeModules[periode][note.key_module] = {
                  name_module: note.name_module,
                  hasExamen: false,
                  hasRattrapage: false,
                };
              }

              if (typeExamen.toLowerCase() === "examen") {
                periodeModules[periode][note.key_module].hasExamen = true;
              } else if (typeExamen.toLowerCase() === "rattrapage") {
                periodeModules[periode][note.key_module].hasRattrapage = true;
              }
            });
          });
        });

        // 2) Construction colonnes dynamiques
        const cols = [
          {
            title: "Apprenant",
            dataIndex: "fullName",
            key: "fullName",
            fixed: "left",
            width: 150,
          },
        ];

        Object.entries(periodeModules).forEach(([periode, modules]) => {
          const subColumns = [];

          Object.entries(modules).forEach(([keyModule, modData]) => {
            const children = [];

            if (modData.hasExamen) {
              children.push({
                title: "Examen",
                dataIndex: `${periode}-examen-${keyModule}`,
                key: `${periode}-examen-${keyModule}`,
                width: 100,
                render: (note) => (note !== undefined ? note : "-"),
              });
            }

            if (modData.hasRattrapage) {
              children.push({
                title: "Rattrapage",
                dataIndex: `${periode}-rattrapage-${keyModule}`,
                key: `${periode}-rattrapage-${keyModule}`,
                width: 100,
                render: (note) => (note !== undefined ? note : "-"),
              });
            }

            subColumns.push({
              title: (
                <Tooltip placement="top" title={modData.name_module}>
                  {keyModule}
                </Tooltip>
              ),
              key: `${periode}-${keyModule}`,
              children,
            });
          });

          cols.push({
            title: `Liste des modules (${periode})`,
            children: subColumns,
          });
        });

        setColumns(cols);

        // 3) Construction des données (ligne par apprenant)
        const dataSource = Array.from(apprenantMap.values()).map((apprenant) => {
          const row = {
            key: apprenant.id,
            fullName: `${apprenant.prenom} ${apprenant.nom}`,
          };

          Object.entries(rawData).forEach(([periode, types]) => {
            Object.entries(types).forEach(([typeExamen, notes]) => {
              notes
                .filter((n) => n.id_apprenant === apprenant.id)
                .forEach((n) => {
                  const colKey = `${periode}-${typeExamen.toLowerCase()}-${n.key_module}`;
                  row[colKey] = n.note;
                });
            });
          });

          return row;
        });

        setApprenants(dataSource);
      })
      .catch(console.error)
      .finally(() => setIsLoading(false));
  }, []);

  return (
     <div>
      <Alert
        type="info"
        style={{ marginBlock: "20px" }}
        message="Configuration"
        description={`Liste des notes`}
        showIcon
      />
      <Card title="Liste des notes" bordered={false}>
      <Table
        loading={isLoading}
        size="small"
        columns={columns}
        dataSource={apprenants}
        className="compact-table"
        bordered
        scroll={{ x: "max-content" }}
      />
  </Card>
  </div>
  );
};

export default ListeNotesApprenants;
